import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useState } from 'react';
import { Alert, Col, Row } from 'reactstrap';
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";
import "./UserExpensesStyles.css";

ModuleRegistry.registerModules([AllCommunityModule]);

function UserBudgetView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Gastos', href: '' }
    ];

    const[rowData, setRowData] = useState([]);

    const [colDefs, setColDefs] = useState([])

    const defaultColDef = {
        flex: 1,
    };

    useEffect(() => {
        setRowData([
            { Partida: "Parranda", Presupuesto: "$ 1 000", Utilizado: 500, Neto: 500 },
            { Partida: "Comida", Presupuesto: "$ 1 000", Utilizado: 1100, Neto: -100 },
            { Partida: "Transporte", Presupuesto: "$ 1 000", Utilizado: 700, Neto: 300 },
            { Partida: "Ahorro", Presupuesto: "$ 1 000", Utilizado: 2000, Neto: -1000 },
            { Partida: "Salud", Presupuesto: "$ 1 000", Utilizado: 0, Neto: 1000 },
            { Partida: "Otros", Presupuesto: "$ 1 000", Utilizado: 100, Neto: 900 },
        ]);
        setColDefs([
            { field: "Partida" },
            { field: "Presupuesto" },
            { field: "Utilizado" },
            { field: "Neto" },
        ]);
    }, []);

	return (
        <MainPageComponent requireAuthentication={true} path={breadcrumbPath} >
            <CenterCenterVerticalContainer>
                <Row>
                    <Col>
                        <h1>Presupuesto del periodo</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Row>
                            Meta del periodo: 5000
                        </Row>
                        <Row>
                            Monto utilizado: 1000
                        </Row>
                        <Row>
                            Monto restante: 4000
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Row>
                            <h5>Detalle del presupuesto</h5>
                        </Row>
                        <Row>
                            <div style={{ width: "90vw", height: "50vh" }}>
                                <AgGridReact
                                    rowData={rowData}
                                    columnDefs={colDefs}
                                    defaultColDef={defaultColDef}
                                />
                            </div>
                        </Row>
                        
                       
                    </Col>
                </Row>
			</CenterCenterVerticalContainer>
		</MainPageComponent>
	);
}

export default UserBudgetView;